module.exports = __webpack_public_path__ + "img/modelos_gg.23f6ee14.png";